class cameraPluginData {
  constructor(vue) {
    this.ctx = vue
    this.scriptNames = ['flv.js']
    this.videoId = null
    this.timer = null
  }
  async init(deep = 0) {
    if (this.ctx.$el) {
      this.initWatcher()
      await this.initScript()
      this.initVideoComponent()
      this.initRTSP()
    } else if (deep < 20) {
      setTimeout(() => {
        this.init(deep + 1)
      }, 50)
    }
  }
  initRTSP() {
    clearInterval(this.timer)
    this.initFlvJs()
    this.timer = setInterval(() => {
      this.initFlvJs()
    }, 1000 * 60 * 4)
  }
  async initFlvJs() {
    const url = await this.getCameraUrl()
    const data = url?.data?.url ? url.data.url : url?.data?.data?.url
    if (!data) {
      throw new Error("视频流地址获取失败")
    }
    console.log("data :>> ", data)
    this.createStreamer(data, 0)
  }
  createStreamer(data, deep) {
    const time1 = new Date().getTime()
    if (flvjs.isSupported()) {
      let video = document.getElementById(this.videoId)
      console.log("video :>> ", video)
      if (video) {
        this.player = flvjs.createPlayer({
          type: "flv",
          isLive: true,
          url: `ws://${location.host}:8888/rtsp/id123?url=${data}`
        })
        this.player.attachMediaElement(video)
        try {
          this.player.load()
          this.player
            .play()
            .then(() => {
              console.log(new Date().getTime() - time1)
              this.loading = false
            })
            .catch(err => {
              console.log(err)
            })
        } catch (error) {
          console.log(error)
        }
      }
    }
  }
  getCameraUrl() {
    return process.env.VUE_APP_MODE === "prod"
      ? this.ctx.instance.get("/app/hikvison/viewUrl/" + this.ctx.options.cameraUrlId)
      : Promise.resolve({
          code: "0",
          msg: "success",
          data: { url: "rtsp://wowzaec2demo.streamlock.net/vod/mp4:BigBuckBunny_115k.mp4" }
        })
  }
  initWatcher() {
    const _self = this
    if (this.ctx.options.hasOwnProperty("cameraUrlId") === false) {
      this.ctx.$changeOptionsEV("", "cameraUrlId", false, null, this.ctx.myid)
    }
    this.ctx.$watch("options.cameraUrlId", function (n, o) {
      _self.initFlvJs.call(_self)
    })
  }
  initVideoComponent() {
    this.videoId = this.ctx.$event.getIdsByStrId(this.ctx.myid) + "cameraPlugin"
    // const video = document.createElement("video")
    // video.setAttribute("id", this.videoId)
    // video.setAttribute("preload", "auto")
    // video.setAttribute("autoplay", "true")
    // video.setAttribute("muted", "muted")
    // video.style.width = "100%"
    // video.style.height = "100%"
    this.ctx.$el.innerHTML = ""
    this.ctx.$el.style.padding = "0"
    this.ctx.$el.innerHTML =
      "<video id=" +
      this.videoId +
      ' style="object-fit:fill;width:100%;height:100%" autoplay="true" controls="false" muted="false" preload="auto"></video>'
  }
  initScript() {
    return new Promise((resolve, reject) => {
      const prevUrl =
        process.env.VUE_APP_MODE === "prod"
          ? `https://static.mh.chaoxing.com/${process.env.VUE_APP_STATIC_URL}/sv2/lib-modules`
          : `http://mh.chaoxing.com/${process.env.VUE_APP_STATIC_URL}/sv2/lib-modules`
      const scriptFind = name =>
        Array.prototype.find.call(document.getElementsByTagName("script"), item => item.src.includes(name))
      const scripts = []
      let count = 0
      for (let i = 0; i < this.scriptNames.length; i++) {
        if (scriptFind(this.scriptNames[i])) continue
        scripts.push(this.createScript(prevUrl + "/" + this.scriptNames[i]))
        count++
      }
      if (scripts.length) {
        for (let i = 0; i < scripts.length; i++) {
          document.body.appendChild(scripts[i])
          scripts[i].onload = function () {
            count--
            if (count === 0) resolve("allLoad")
          }
        }
      } else resolve()
    })
  }
  createScript(name) {
    const script = document.createElement("script")
    const scriptSrc = name
    script.setAttribute("src", scriptSrc)
    script.setAttribute("async", "async")
    return script
  }
}
export default {
  data() {
    return {
      cameraPluginData: new cameraPluginData(this)
    }
  },
  methods: {
    cameraPlugin() {
      console.log("cameraPlugin")
      this.cameraPluginData.init()
    }
  },
  beforeDestroy() {
    clearInterval(this.cameraPluginData.timer)
  }
}
